import React, { useState, useEffect } from 'react';

function ValueStory () {
    return (
        <main id="value_story" className="overview">
        </main>
    );
}

export default ValueStory;